import { CONSUMER_SESSION_REDIRECT_TO } from "../constants";

const useAuthRedirect = () => {
  const getRedirectUrl = () =>
    sessionStorage.getItem(CONSUMER_SESSION_REDIRECT_TO) || "/";

  const setRedirectUrl = url =>
    sessionStorage.setItem(CONSUMER_SESSION_REDIRECT_TO, url);

  const removeRedirectUrl = () =>
    sessionStorage.removeItem(CONSUMER_SESSION_REDIRECT_TO);

  return { getRedirectUrl, setRedirectUrl, removeRedirectUrl };
};

export { useAuthRedirect };
